// extracted by css-extract-rspack-plugin
export default {"result":"AdfoxInfoResult-module__result--FAw9F","field-list":"AdfoxInfoResult-module__field-list--kZF_Z","fieldList":"AdfoxInfoResult-module__field-list--kZF_Z"};